<script setup>
import { computed, ref } from 'vue';
import { useI18n } from 'vue-i18n';
import PlayerIconButton from '@/components/quran/player/PlayerIconButton.vue';
import { useQuranSettings } from '@/composables/quran/useQuranSettings';

/** Mute toggle and a volume slider; remembers the level to restore after mute. */
const { t } = useI18n();
const settings = useQuranSettings();
const restoreTo = ref(settings.volume || 1);

const icon = computed(() => {
  if (settings.volume === 0) return 'solar:volume-cross-linear';
  return settings.volume < 0.5 ? 'solar:volume-small-linear' : 'solar:volume-loud-linear';
});

function toggleMute() {
  if (settings.volume > 0) {
    restoreTo.value = settings.volume;
    settings.volume = 0;
  } else {
    settings.volume = restoreTo.value || 1;
  }
}
</script>

<template>
  <div class="flex items-center gap-1">
    <PlayerIconButton :icon="icon" size="sm" :label="t('quran.player.volume')" @click="toggleMute" />
    <input
      v-model.number="settings.volume"
      type="range"
      min="0"
      max="1"
      step="0.05"
      :aria-label="t('quran.player.volume')"
      class="w-24 h-1 rounded-full appearance-none cursor-pointer bg-white/15 accent-[#ecd79f]"
      :style="{ background: `linear-gradient(to right, #ecd79f ${settings.volume * 100}%, rgba(255,255,255,0.15) ${settings.volume * 100}%)` }"
    />
  </div>
</template>
